export const FETCH_THIRDPARYDATA_DETAIL_BEGIN="FETCH_THIRDPARYDATA_DETAIL_BEGIN";
export const FETCH_THIRDPARYDATA_DETAIL_SUCCESS="FETCH_THIRDPARYDATA_DETAIL_SUCCESS";
export const FETCH_THIRDPARYDATA_DETAIL_FAILURE="FETCH_THIRDPARYDATA_DETAIL_FAILURE";